import { render, staticRenderFns } from "./RogueClassified.vue?vue&type=template&id=28331447&"
import script from "./RogueClassified.vue?vue&type=script&lang=ts&"
export * from "./RogueClassified.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports